import { GlobalContext } from '@context/Global/GlobalContext';
import { useContext } from 'react';

export const useGlobal = () => {
    const { globalState, setLoggedIn, setLoading, setCurrentFcStore, setParamsNavigator } = useContext(GlobalContext);
    const { isLoading, isLoggedIn, currentFcStore, paramsNavigator } = globalState;
    return {
        isLoading: isLoading,
        isLoggedIn: isLoggedIn,
        currentFcStore: currentFcStore,
        paramsNavigator,
        setLoggedIn,
        setLoading,
        setCurrentFcStore,
        setParamsNavigator,
    };
};
